module.exports = __webpack_public_path__ + "img/partner.4170e6f0.png";